import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_2 = { class: "row mb-2" }
const _hoisted_3 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_4 = { class: "col-sm-8" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "row mb-2" }
const _hoisted_7 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_8 = { class: "col-sm-8" }
const _hoisted_9 = { class: "row mb-2" }
const _hoisted_10 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_11 = { class: "col-sm-8" }
const _hoisted_12 = { class: "row mb-2" }
const _hoisted_13 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_14 = { class: "col-sm-8" }
const _hoisted_15 = { class: "row mb-3" }
const _hoisted_16 = { class: "col-sm-12" }
const _hoisted_17 = { class: "p-0 m-0" }
const _hoisted_18 = { class: "col-sm-12" }
const _hoisted_19 = { class: "me-2" }
const _hoisted_20 = {
  key: 0,
  class: "spinner-border",
  role: "status",
  style: {"zoom":"0.5"}
}
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_23 = { class: "col-sm-12" }
const _hoisted_24 = ["id"]
const _hoisted_25 = ["src"]
const _hoisted_26 = {
  key: 0,
  class: "col-sm-12"
}
const _hoisted_27 = {
  key: 0,
  class: "text-success d-block"
}
const _hoisted_28 = { class: "text-danger d-block" }
const _hoisted_29 = {
  key: 1,
  class: "col-sm-12"
}
const _hoisted_30 = {
  class: "text-secondary",
  style: {"word-break":"break-all"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    title: _ctx.helper.trans('labels.receipt_verification'),
    modelValue: _ctx.modal !== null,
    "footer-class": "d-flex justify-content-between",
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ($event === false && (_ctx.modal = null)))
  }, {
    default: _withCtx(() => [
      (_ctx.stopScamEnabled)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.helper.trans('stopscam.manual.payment_method')), 1),
              _createElementVNode("div", _hoisted_4, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.paymentMethod) = $event)),
                  class: "form-select form-select-sm"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentMethods, (method) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: method,
                      value: method
                    }, _toDisplayString(_ctx.helper.trans(`stopscam.manual.${method}`)), 9, _hoisted_5))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.form.paymentMethod]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.helper.trans('stopscam.manual.requisite')), 1),
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.requisite) = $event)),
                  type: "text",
                  class: "form-control form-control-sm"
                }, null, 512), [
                  [_vModelText, _ctx.form.requisite]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.helper.trans('stopscam.manual.bank_name')), 1),
              _createElementVNode("div", _hoisted_11, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.bankName) = $event)),
                  type: "text",
                  class: "form-control form-control-sm"
                }, null, 512), [
                  [_vModelText, _ctx.form.bankName]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.helper.trans('stopscam.manual.amount')), 1),
              _createElementVNode("div", _hoisted_14, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.amount) = $event)),
                  type: "text",
                  inputmode: "decimal",
                  class: "form-control form-control-sm"
                }, null, 512), [
                  [_vModelText, _ctx.form.amount]
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _mergeProps({ style: {"cursor":"pointer","border":"1px dashed"} }, _ctx.dropzone.getRootProps(), { class: "payout-dropzone rounded border-secondary p-3 pt-4 pb-4 d-flex justify-content-center align-items-center" }), [
            _createElementVNode("input", _normalizeProps(_guardReactiveProps(_ctx.dropzone.getInputProps())), null, 16),
            _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.helper.trans('labels.payout_upload_files')), 1)
          ], 16)
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileAttachments, (fileAttachment) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "row mb-2 ms-2",
          key: fileAttachment.id
        }, [
          _createElementVNode("div", _hoisted_18, [
            _cache[8] || (_cache[8] = _createElementVNode("i", { class: "fa fa-paperclip" }, null, -1)),
            _cache[9] || (_cache[9] = _createTextVNode()),
            _createElementVNode("span", _hoisted_19, _toDisplayString(fileAttachment.file.name), 1),
            (fileAttachment.error === null && fileAttachment.attachment === null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, _cache[6] || (_cache[6] = [
                  _createElementVNode("span", { class: "visually-hidden" }, null, -1)
                ])))
              : (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  href: "#",
                  onClick: _withModifiers(($event: any) => (_ctx.removeFile(fileAttachment)), ["prevent"])
                }, _cache[7] || (_cache[7] = [
                  _createElementVNode("i", { class: "fa fa-times" }, null, -1)
                ]), 8, _hoisted_21)),
            _createElementVNode("div", null, [
              (fileAttachment.error !== null)
                ? (_openBlock(), _createElementBlock("small", _hoisted_22, _toDisplayString(fileAttachment.error), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            (fileAttachment.isPdf)
              ? (_openBlock(), _createElementBlock("canvas", {
                  key: 0,
                  id: `pdf-canvas-${fileAttachment.id}`,
                  class: "w-100"
                }, null, 8, _hoisted_24))
              : (fileAttachment.previewUrl)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: fileAttachment.previewUrl,
                    class: "w-100",
                    alt: ""
                  }, null, 8, _hoisted_25))
                : _createCommentVNode("", true)
          ]),
          (_ctx.stopScamEnabled && fileAttachment.attachment && fileAttachment.error === null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                (fileAttachment.attachment.passed)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_27, [
                      _cache[10] || (_cache[10] = _createElementVNode("i", { class: "fa-solid fa-circle me-1" }, null, -1)),
                      _createTextVNode(_toDisplayString(_ctx.helper.trans('stopscam.passed')), 1)
                    ]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("small", _hoisted_28, [
                        _cache[11] || (_cache[11] = _createElementVNode("i", { class: "fa-solid fa-circle me-1" }, null, -1)),
                        _createTextVNode(_toDisplayString(_ctx.helper.trans('stopscam.failed')), 1)
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileAttachment.attachment.verdicts, (verdict) => {
                        return (_openBlock(), _createElementBlock("small", {
                          key: verdict,
                          class: "text-danger d-block ms-3"
                        }, _toDisplayString(_ctx.helper.trans(`stopscam.verdict.${verdict}`, {}, verdict)), 1))
                      }), 128))
                    ], 64))
              ]))
            : (fileAttachment.attachment)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _createElementVNode("small", _hoisted_30, _toDisplayString(JSON.stringify(fileAttachment.attachment)), 1)
                ]))
              : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.modal = null)),
        class: "btn btn-outline-dark btn-sm text-capitalize-first"
      }, _toDisplayString(_ctx.helper.trans('button.ok')), 1)
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}